// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1FCoQ","buttons":"SendReceipts_buttons__1-aSC","email":"SendReceipts_email__1KEcQ","bookApptTitle":"SendReceipts_bookApptTitle__1_WOF"};